import get from 'lodash-es/get'
import * as React from 'react'

import { BaseVideoPlayer, PlayState } from '@envato/react-video'
import { formatClassfication } from '../../../../common/utils/searchResultFormator'
import Magnifier from './magnifier'

const MagnifierConfigurator = ({
  item,
  videoMuted,
  muteVideo
}: {
  item: any
  videoMuted?: boolean
  muteVideo?: () => void
}) => {
  const previews = item.previews
  const formattedClassifcation = formatClassfication(item.classification)

  const getMagnifier = () => {
    if (get(previews, 'icon_with_square_preview.square_url')) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          price={item.ui.price}
          pricePeriod={item.ui.pricePeriod}
          classification={formattedClassifcation}
          width={300}
          height={300}
        >
          <img
            alt={get(item, 'description')}
            src={previews.icon_with_square_preview.square_url}
          />
        </Magnifier>
      )
    }

    if (get(previews, 'icon_with_thumbnail_preview.thumbnail_url')) {
      const width = previews.icon_with_thumbnail_preview.thumbnail_width || 300
      const height =
        previews.icon_with_thumbnail_preview.thumbnail_height || 300
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          price={item.ui.price}
          pricePeriod={item.ui.pricePeriod}
          classification={formattedClassifcation}
          width={width}
          height={height}
        >
          <img
            alt={get(item, 'description')}
            src={previews.icon_with_thumbnail_preview.thumbnail_url}
          />
        </Magnifier>
      )
    }

    if (get(previews, 'icon_with_video_preview.video_url')) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          price={item.ui.price}
          pricePeriod={item.ui.pricePeriod}
          classification={formattedClassifcation}
          width={477}
          height={264}
        >
          <BaseVideoPlayer
            playState={PlayState.PLAY}
            muteVideo={muteVideo}
            loop
            muted={videoMuted}
            preload="none"
            src={previews.icon_with_video_preview.video_url}
            poster={previews.icon_with_video_preview.landscape_url}
          />
        </Magnifier>
      )
    }

    if (get(previews, 'icon_with_landscape_preview.landscape_url')) {
      return (
        <Magnifier
          name={item.name}
          authorName={item.author_username}
          price={item.ui.price}
          pricePeriod={item.ui.pricePeriod}
          classification={formattedClassifcation}
          width={477}
          height={240}
        >
          <img
            alt={get(item, 'description')}
            src={previews.icon_with_landscape_preview.landscape_url}
          />
        </Magnifier>
      )
    }

    return null
  }

  return <div className="fds-u-hide-small-and-below">{getMagnifier()}</div>
}

export default MagnifierConfigurator
